<style scoped>
.br-10 {
  padding: 10px;
  border-radius: 10px;
}
</style>

<template>
  <v-container fluid>
    <v-alert v-if="error" id="error" :value="error !== null" class="br-10 dark font-weight-bold" type="error">{{ error.error | uppercase }}</v-alert>
    <v-alert v-if="error === null & success" id="success" class="br-10 dark" type="success">
      <span class="subheading font-weight-bold">Password has been reset.</span>
    </v-alert>
    <v-layout v-if="error === null && success === false" justify-center>
      <v-flex xl4 lg6 md7 sm10 xs12>
        <v-card class="br-10 text-center">
          <v-layout class="pa-3" column wrap >
            <span class="title primary--text"><strong>{{ $t('reset_password') }}</strong></span>
            <v-form @submit.prevent="submitForm($event)">
              <v-text-field ref="password" v-validate="rules.password" id="password" :error-messages="errors.collect('password')" :value="data.password" :label="$t('password')" prepend-icon="fa-lock fa-lg" name="password" required type="password" @input="patchData({ password: $event })"/>
              <v-text-field v-validate="'required:confirm_password'" id="confirm_password" :error-messages="errors.collect('confirm_password')" :value="data.confirm_password" :label="$t('confirm_password')" prepend-icon="fa-lock fa-lg" name="confirm_password" required type="password" @input="patchData({ confirm_password: $event })"/>
            </v-form>
          </v-layout>
        </v-card>
        <v-layout justify-end pt-2>
            <v-btn :block="$vuetify.breakpoint.xsOnly" color="red lighten-1" class="white--text" large rounded @click="$router.push('/')">{{ $t('cancel') }}</v-btn>
          <v-btn :block="$vuetify.breakpoint.xsOnly" :disabled="!isValid || isLoading" :loading="isLoading" color="primary" large rounded type="submit">{{ $t('submit') }}</v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      isLoading: 'reset/isLoading'
    }),
    ...mapState({
      data: state => state.reset.data,
      error: state => state.reset.error,
      rules: state => state.reset.rules,
      success: state => state.reset.success
    }),
    isValid: function () {
      return (
        Object.keys(this.fields).every(key => this.fields[key].valid) &&
        this.data.password === this.data.confirm_password
      )
    }
  },
  created: async function () {
    if (this.$route.params.id) {
      await this.$store.dispatch(
        'reset/patchId',
        this.$route.params.id
      )
    } else {
      await this.$store.commit('reset/setError', {
        error: { reason: 'Something wrong, please try again.' }
      })
    }
  },
  methods: {
    ...mapActions({
      patchData: 'reset/patchData',
      patchId: 'reset/patchId',
      resetData: 'reset/resetData',
      setError: 'reset/setError',
      submitData: 'reset/submitData'
    }),
    submitForm: async function () {
      if (!(await this.$validator.validateAll())) return
      await this.submitData()
      this.resetData()
      this.$validator.reset()
    }
  }
}
</script>
